// Application constants

export const USER_ROLES = {
  CUSTOMER: 'customer',
  PROVIDER: 'provider',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin'
};

export const BOOKING_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  DISPUTED: 'disputed'
};

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  REFUNDED: 'refunded'
};

export const PROVIDER_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  SUSPENDED: 'suspended',
  INACTIVE: 'inactive'
};

export const LOYALTY_TIERS = {
  BRONZE: 'bronze',
  SILVER: 'silver',
  GOLD: 'gold',
  PLATINUM: 'platinum'
};

export const SERVICE_CATEGORIES = [
  'Childcare',
  'Healthcare',
  'Wellness',
  'Consultation',
  'Photography'
];

export const DISPUTE_PRIORITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high'
};

export const DISCOUNT_TYPE = {
  PERCENTAGE: 'percentage',
  FIXED: 'fixed'
};

export const NOTIFICATION_TYPES = {
  BOOKING: 'booking',
  PAYMENT: 'payment',
  CHAT: 'chat',
  PROMOTION: 'promotion',
  SYSTEM: 'system'
};

const API_URL = 'https://tiny-api.smitiv.co/api'
export const API_BASE_URL = API_URL;

export const ITEMS_PER_PAGE = 10;

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const SINGAPORE_BANKS = [
    'DBS Bank',
    'OCBC Bank',
    'UOB (United Overseas Bank)',
    'Standard Chartered Bank',
    'Citibank Singapore',
    'HSBC Singapore',
    'Maybank Singapore',
    'Bank of China (Singapore)',
    'RHB Bank',
    'CIMB Bank',
    'ANZ Bank Singapore',
    'BNP Paribas Singapore',
    'Deutsche Bank Singapore',
    'Bank of America Singapore',
    'Barclays Singapore',
    'Credit Suisse Singapore',
    'UBS Singapore',
    'ICICI Bank Singapore',
    'State Bank of India Singapore',
    'Axis Bank Singapore',
    'IndusInd Bank Singapore',
    'Far Eastern Bank',
    'HL Bank Singapore',
    'ICBC Singapore',
    'Mizuho Bank Singapore',
    'MUFG Bank Singapore',
    'Sumitomo Mitsui Banking Corporation',
    'Bank of India Singapore',
    'Canara Bank Singapore',
];